export default __webpack_public_path__ + "static/094-cfdf49c78a4c9b83d086ac1924b0a16d.jpg";